import React from "react";
import DonationContainer from "./index.css";

const Account = () => {
  return (
    <DonationContainer>
      <h1>후원계좌</h1>
    </DonationContainer>
  );
};

export default Account;
